import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import $ from 'jquery';

import ucfirst from '../tools/ucfirst';
import ProgressBar from '../components/ProgressBar';
import AcceptLeadButton from '../components/AcceptLeadButton';

class InvalidLeadView extends React.Component {
  render() {
    console.log(`Viewing lead id: ${this.props.lead.id} uid: ${this.props.lead.uid}`);

    return (
      <div>
        <div className="l-lead-modal">
          <header className="l-lead-modal-section">
            <h1 className="t-header">{this.props.lead.headline}</h1>
          </header>

          <div className="l-lead-modal-section t-content">
            <p>This lead is no longer available.</p>
          </div>

          <footer className="l-lead-modal-section l-lead-modal-ctas">
            <div className="l-lead-modal-cta-ignore">
              <button type="button" onClick={this.props.onClose} className="btn btn--emphasis btn--block btn--muted">Close</button>
            </div>
          </footer>

          <small className="t-small">
            Lead UID: { this.props.lead.uid }
          </small>
        </div>
      </div>
    );
  }
}

InvalidLeadView.propTypes = {
  lead: PropTypes.object.isRequired
};

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(InvalidLeadView);
